module.exports = __webpack_public_path__ + "static/media/krx-public-07.617c5508.jpg";